const MAX_BODY_LENGTH = 4000;

const isClientError = (status) => status >= 400 && status < 500;

export const serializeBody = (data) => {
  const body = typeof data === "string" ? data : JSON.stringify(data);
  return body?.slice(0, MAX_BODY_LENGTH);
};

export const attachAxiosResponse = (event, hint) => {
  const error = hint?.originalException;
  const status = error?.response?.status;
  if (!error?.isAxiosError || !isClientError(status)) return event;

  event.contexts = {
    ...event.contexts,
    response: {
      type: "response",
      status_code: status,
      method: error.config?.method?.toUpperCase(),
      url: error.config?.url,
      data: serializeBody(error.response.data),
    },
  };
  event.tags = { ...event.tags, http_status: String(status) };
  return event;
};
